import React,{memo} from 'react';
import SubformTypeForm from './SubformTypeForm';
import SectionTypeForm from './SectionTypeForm';
import StepsTypeForm from './StepsTypeForm';
import ApprovalTypeForm from './ApprovalTypeForm';
import isEmpty from "lodash/isEmpty";
import Wrp from '../../../hoc/Wrp/Wrp';
import { isSet } from '../../../Utils/CommonFunctions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import GlobalLoader from '../../../Components/Loader/GlobalLoader';


const  FormContentData = memo((props)=>{    
    const {isPopupWindow} = props;
    let {fieldGroups} = props;

    
    // my code 07 - For show subform only
    if(props.isSubFormOnly === true){
      fieldGroups = props.fieldGroupsForSubformOnly;
    }
    // endss

    let inc=0;
    //For Reminder component
    const reminderDisplayText = [];
    let field=[]
    let quickData=[]
    if(props.isQuickCreate===true){
    fieldGroups.forEach((section,sectionIndex) => { 
      section.data.forEach((field,fieldIndex)=>{
           quickData.push(field)
      })
    })
    field=[{...props.fieldGroups[0],data:quickData}]
    }
    (props.isQuickCreate===true?field:fieldGroups).map((section)=>{
      if(section.access_mode!=='HIDDEN'){
        section.data.map((field)=>{
          if(field.access_mode!=='HIDDEN' && field.element!=='Reminder'){
            if(isSet(field.label,null)!==null){
              reminderDisplayText.push({
                label:field.label.blocks[0].text,
                fieldId:field.id,
                sectionIndex:section.section_index
              })
            }
          }
        })
      }
    });
    
  //   const changeInputHandler = (obj,evnt,type) => {
  //     props.onChangeInputAction(obj,evnt,type);
  //     if (typingTimeout) {
  //         clearTimeout(typingTimeout);
  //     }
  //     console.log('typing...');
  //     setTypingTimeout(setTimeout(() => {
  //         props.onBlurHandlerAction(obj,evnt,type);
  //     }, 500));
  // };
    //console.log('fieldGroups===',fieldGroups)
    return(
      <React.Fragment>
        {(props.isQuickCreate===true?field:fieldGroups).length>0? 
        <React.Fragment>
          {(props.isQuickCreate===true?field:fieldGroups).map((section, secIndex) => {
        //const FormTypeComp =  (isSet(props.sectionType,'Default')==='Steps')?StepsTypeForm:(section.type==='subform')?SubformTypeForm:SectionTypeForm;
        // const FormTypeComp =  (section.type==='subform')?SubformTypeForm:SectionTypeForm;
        // if(isEmpty(section.data) || isSet(section.access_mode,'EDITABLE')==='HIDDEN'){
        //   return false;
        // }

        // my code 07 - For layoutform display
        let FormTypeComp = SectionTypeForm;
        if(isSet(props.sectionType,'Default')==='Steps'){          
          FormTypeComp =  (section.type==='subform')?SubformTypeForm:StepsTypeForm;
        }else if(isSet(props.sectionType,'Default')==='Approval'){          
          FormTypeComp =  (section.type==='subform')?SubformTypeForm:ApprovalTypeForm;
        }else{          
          FormTypeComp =  (section.type==='subform')?SubformTypeForm:SectionTypeForm; 
        }
        let sectionType = 'Default';
        sectionType = isSet(props.sectionType,'Default');
        // endss


        

        //For Quick Create
        if(props.isQuickCreate===true){
          section = {
            ...section,
            column_type:'single',
            data:section.data.filter((itm)=>{
              if(itm.quickCreate===true){
                return itm;
              }
            }).slice().sort((a,b)=> a.qcItemIndex-b.qcItemIndex)
          }
        }
        //Filter and ignore sections
        if(isFilterFormFields(section,props.isQuickCreate)===false){
          return false;
        }
        inc++;

        return(
          <Wrp key={inc}>
          <FormTypeComp 
            {...props}
            section={JSON.stringify(section)}
            column_type={section.column_type}
            sectionIndex={secIndex}
            modType={props.modType}
            isPopupWindow={isPopupWindow}
            windowDetails={props.windowDetails}
            onChangeInputAction={props.onChangeInputAction}
            onBlurHandlerAction={props.onBlurHandlerAction}
            // DVauditLog={props.DVauditLog}
            reminderDisplayText={reminderDisplayText}
            isQuickCreate={props.isQuickCreate}
            validationForms={props.validationForms}
            pageType={'form'} 
            sectionType={sectionType}
          />
            </Wrp>
        )
      })}
        </React.Fragment>
        :<React.Fragment>
          <GlobalLoader />
        </React.Fragment>}
        
      </React.Fragment>
    )
  });

const isFilterFormFields =  (SecData,isQuickCreate=false)=>{
  let returnData = true;
  if(isQuickCreate===true){
    let quickCreateIsExist = 0;
    SecData.data.map((item)=>{
      //&& item.element!=='Lookup' && item.element!=='MultiLookup'
      if(item.quickCreate==true){
        if(isSet(SecData.access_mode,'EDITABLE')!=='HIDDEN'){
          quickCreateIsExist++;
        }
      }
    })
    returnData = (quickCreateIsExist>0)?true:false
 }else if(isEmpty(SecData.data) || isSet(SecData.access_mode,'EDITABLE')==='HIDDEN' ||SecData.data.is_add_form===false){
    returnData = false;
  }
 
  return returnData;
}

FormContentData.defaultProps = {
  isSubFormOnly: false,  
}

// const mapDispatchToProps = dispatch => {
//     return {
//     //   setVariablesPayloadAction:(obj)=>dispatch(setVariablesPayloadAction(obj)),
//     };
//   }
  const mapStateToProps = (state,props) => { 
    return {
        fieldGroups : state.formBuilder.fieldGroups[props.modType],
        nonFieldGroups : state.formBuilder.nonFieldGroups[props.modType],
        subformData:state.formBuilder.subformData[props.modType],
        validationForms:state.formBuilder.validationForms[props.modType],
    };
  }
export default
    connect(
      mapStateToProps, 
      null
    )(withRouter(FormContentData));